import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit} from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import moment from 'moment-timezone';
import { AuthService } from 'src/app/auth/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-launch-page',
  templateUrl: './launch-page.component.html',
  styleUrls: ['./launch-page.component.scss']
})
export class LaunchPageComponent implements OnInit {

currentLinkStatus:any;
isSpinner:boolean;
versionNo:any
payload:any;
mapname:any;
mapid:any;
deviceid:any;
devicename:any;
imeis = []
token:any;
file:any;
locname:any;
filter:{}={};
modemData:any;
isLinkValid=false;
reason:any

constructor( private route:ActivatedRoute, 
             public router: Router, private commonServices:CommonService, 
             private httpClient:HttpClient,
             private authServices:AuthService,
             @Inject('apiEndPoint') private apiEndPoint: string,
             @Inject('fileServerUrl') private fileServerUrl :string,
             @Inject('version') private version: string,){
let param = this.route.snapshot.paramMap.get('name')
if(!param){
  this.router.navigate(['/login'])
}
else{
 this.httpClient.get(`${this.fileServerUrl}/_login/local/${param}`).subscribe((res:any)=>{
  // this.httpClient.get(`http://localhost:3100/_login/local/${param}`).subscribe((res:any)=>{
  console.log(res)
  if(res?.output?._id==param){
    let output = res?.output
    this.mapid = output?._source?.payload?.mapid;
    this.file = output?._source?.file
    this.mapname = output?._source?.payload?.mapname;
    this.imeis = output?._source?.payload?.devices?output?._source?.payload?.devices.map(each=>each?.imei):[];
    this.deviceid = output?._source?.payload?.devices?.[0]?.deviceid;
    this.devicename = output?._source?.payload?.devicename;
    this.token = res?.token;
    this.locname = param;
    this.filter = output?._source?.payload;
    this.modemData = output?._source?.modemData?.data;
    let now  = new Date().valueOf();
    if(now>=output?._source?.starttime&&now<=output?._source?.endtime){
        const filter = {
          query:{
            bool:{
              must:[
                {"query_string":{ "query": this.locname, "type": "phrase", "fields": ["locname"]}}
              ]
            }
          },sort:{"_kuzzle_info.createdAt": "desc"}
        }
        this.isLinkValid = true;
        // this.httpClient.post(`${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=10`, filter).subscribe((response:any)=>{
        //   let length=0;
        //   console.log(response);
        //   response?.result?.hits&&(length = response?.result?.hits.length);
        //   if(length==0){
        //     this.isLinkValid = true;
        //   }else{
        //     if(response?.result?.hits&&length>0){
        //       let stausLength=0;
        //       response?.result?.hits.map((each:any)=>{
        //         if(each?._source?.status=='Stopped_Applied'){
        //                  stausLength++;
        //         }
        //       })
        //         if(stausLength==length){
        //           this.reason = 'All tests completed';
        //         }else{
        //           this.isLinkValid = true;
        //         }
        //     }
        //   }

        // })
      
    }
    else if(now<output?._source?.starttime){
          this.reason = [`Link will be active between`, `${moment(output?._source?.starttime).format("dddd, MMMM Do YYYY, h:mm:ss a")}`, `and`,`${moment(output?._source?.endtime).format("dddd, MMMM Do YYYY, h:mm:ss a")}`];
    }
    else if(now>output?._source?.endtime){
          this.reason = [`Test ended at`, `${moment(output?._source?.endtime).format("dddd, MMMM Do YYYY, h:mm:ss a")}`];
    }
  }
  else{
    this.router.navigate(['/login'])
  }
})
}

}ngOnInit(): void {
    this.versionNo=this.version;
  }
;

handleLaunchTest(){
  localStorage.setItem('token', this.token)
  let intvl = setInterval(()=>{
    let tkn = localStorage.getItem('token');
    if(tkn){
      clearInterval(intvl);
        this.commonServices.reroutingSubject.next({
          mapid:this.mapid,
          mapname:this.mapname,
          file:this.file,
          imei:this.imeis,
          maptype:this.file?"Indoor":"Outdoor",
          deviceid:this.deviceid,
          devicename:this.devicename,
          locname:this.locname,
          filter:this.filter,
          modemData:this.modemData,
          type:'launch'
        })
        this.router.navigate(['/live-walk-test']);
    }
  },500)
  
}

}
